// @ts-nocheck
import React from 'react';

interface QuickFilter {
  id: string;
  label: string;
  icon: string;
  onClick: () => void;
  count?: number;
}

interface AdminQuickFiltersProps {
  filters: QuickFilter[];
  activeFilter?: string;
  className?: string;
}

export const AdminQuickFilters: React.FC<AdminQuickFiltersProps> = ({
  filters,
  activeFilter,
  className = '',
}) => {
  if (filters.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={filter.onClick}
          className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors min-h-[44px] touch-manipulation ${
            activeFilter === filter.id
              ? 'bg-luna-secondary text-white'
              : 'bg-white dark:bg-luna-primary border border-luna-secondary/30 text-luna-text-light dark:text-luna-text-dark hover:bg-luna-secondary/10 active:bg-luna-secondary/20'
          }`}
        >
          <span className="material-symbols-outlined text-base">{filter.icon}</span>
          <span>{filter.label}</span>
          {filter.count !== undefined && (
            <span
              className={`px-1.5 py-0.5 rounded text-xs ${
                activeFilter === filter.id
                  ? 'bg-white/20 text-white'
                  : 'bg-luna-secondary/10 text-luna-secondary'
              }`}
            >
              {filter.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

